import React, { useRef, useEffect, useState } from 'react'
import Barcode from 'react-barcode'

import LabelCard from '../LabelCard'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarafiyat } from '../../../../../assets/zarafiyat.svg'
import QrSvg from '@wojtekmaj/react-qr-svg'
import tshirtlogo from '../../../../../assets/tshirtinfo.svg'
import QRCodeStyling from 'qr-code-styling'
import { ReactComponent as MySVG } from '../../../../../assets/fsc.svg'
import { ReactComponent as MySVG2 } from '../../../../../assets/logolar-02.svg'
import { ReactComponent as MySVG3 } from '../../../../../assets/logolar-03.svg'
import { ReactComponent as MySVG4 } from '../../../../../assets/logolar-04.svg'
import { ReactComponent as MySVG5 } from '../../../../../assets/logolar-05.svg'
import { ReactComponent as MySVG6 } from '../../../../../assets/Varlık1.svg'
import { ReactComponent as ALARM } from '../../../../../assets/alarm (1).svg'

import { ReactComponent as MySVG7 } from '../../../../../assets/pricetopsvg/pricehomebathroom.svg'
import { ReactComponent as MySVG8 } from '../../../../../assets/pricetopsvg/GLOBAL.svg'
import { ReactComponent as MySVG9 } from '../../../../../assets/pricetopsvg/DENIMWEAR.svg'
import { ReactComponent as MySVG10 } from '../../../../../assets/pricetopsvg/WOMANBASICKARE.svg'
import { ReactComponent as MySVG11 } from '../../../../../assets/pricetopsvg/WOMANBASICCIRCLE.svg'
import { ReactComponent as MySVG12 } from '../../../../../assets/pricetopsvg/WOMANBASICTRIANGLE.svg'
import { ReactComponent as MySVG13 } from '../../../../../assets/pricetopsvg/KIDSBABYBOY.svg'
import { ReactComponent as MySVG14 } from '../../../../../assets/pricetopsvg/KIDSBABYGIRL.svg'
import { ReactComponent as MySVG15 } from '../../../../../assets/pricetopsvg/KIDSBOYKARE.svg'
import { ReactComponent as MySVG16 } from '../../../../../assets/pricetopsvg/KIDSGIRLDAIRE.svg'
import { ReactComponent as MySVG17 } from '../../../../../assets/pricetopsvg/KIDSBABYUNIT.svg'

import { ReactComponent as MySVG18 } from '../../../../../assets/altbestlogo.svg'
import { ReactComponent as MyLogoHarman } from '../../../../../assets/altlogoharman.svg'
import { BASE_URL2 } from 'config/axios'
import { ReactComponent as ZaraLogoNewFullfill } from '../../../../../assets/zarahome/fscfullfilnew.svg'

import { ReactComponent as MySVG19 } from '../../../../../assets/talla.svg'
import { ReactComponent as MySVG20 } from '../../../../../assets/usuk.svg'
import { ReactComponent as MySVG249 } from '../../../../../assets/justus.svg'
import { ReactComponent as MySVG250 } from '../../../../../assets/justuk.svg'
import { ReactComponent as MySVG21 } from '../../../../../assets/usamexuk.svg'
import { ReactComponent as MySVG22 } from '../../../../../assets/lineline.svg'
import { ReactComponent as MySVG2900 } from '../../../../../assets/RDOLAR.svg'
import { ReactComponent as MySVGTry } from '../../../../../assets/55110.svg'
import { useAuth } from 'store/client/authStore'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg';
import { ReactComponent as BlackDenim } from '../../../../../assets/black-denimwear.svg' // SVG'yi React bileşeni olarak içe aktarma

import { ReactComponent as ZaraFscrr } from '../../../../../assets/zarahome/newfscrr.svg'
import { ReactComponent as ZaraFsctm } from '../../../../../assets/zarahome/newfsctm.svg'
import { ReactComponent as ZaraFsctmpaper } from '../../../../../assets/zarahome/newfsctmpaper.svg'
import { ReactComponent as ZaraGeneralBack } from '../../../../../assets/zarahome/generalback.svg'
import { ReactComponent as ALARMHOME } from '../../../../../assets/zarahome/ALARMHOME.svg'

import { ReactComponent as Ceramic } from '../../../../../assets/zarahome/ceramic.svg'


import { ReactComponent as Path689 } from '../../../../../assets/zarahome/path689.svg'
import { ReactComponent as Label1011 } from '../../../../../assets/zarahome/280x70.svg'
import { ReactComponent as Label38870 } from '../../../../../assets/zarahome/388x70.svg'
import { ReactComponent as Label28070V2 } from '../../../../../assets/zarahome/280x70V2.svg'
import { ReactComponent as Label32070 } from '../../../../../assets/zarahome/320x70.svg'
import { ReactComponent as Label32045 } from '../../../../../assets/zarahome/320x45.svg'

import { ReactComponent as LabelKıds115x136 } from '../../../../../assets/zarahome/KIDS115x136.svg'

import { ReactComponent as LabelKıds100x200 } from '../../../../../assets/zarahome/KIDS100x200.svg'
import { ReactComponent as LabelKıds100x200WM } from '../../../../../assets/zarahome/KIDS100x200WM.svg'



import { ReactComponent as Pack2 } from '../../../../../assets/zarahome/pack2.svg'
import { ReactComponent as Pack3 } from '../../../../../assets/zarahome/pack3.svg'
import { ReactComponent as G704Zara } from '../../../../../assets/zarahome/g704.svg'
import { ReactComponent as TempBack } from '../../../../../assets/zarahome/yantroppernew_optimized.svg'
import { ReactComponent as TempArka } from '../../../../../assets/zarahome/label10yatayuzun_optimized.svg'



import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { LiaCircleSolid } from 'react-icons/lia'
import { BiSolidCircle } from 'react-icons/bi'
import DynamicShrinkText from './DynamicShrinkText'
import DynamicTextLeftt from './DynamicShrinkLefft'
import RenderIndoItems from './RenderIndoItems'
import RenderIndoItemsCM from './RenderIndoItemsCM'
import DynamicTextKids from './DynamicTextKids'
import RenderIndoItemsKids from './RenderIndoItemsKıds'
import QRCodeComponentLabel10 from './qrcodecomponentlabel10'

export default function Label10({
  sizeData,
  renderShape,
  Path1,
  selectColor = 0,
  barcodeValue,
  qrcodeValue,
  data,
  indo,
  inx,
  szrgrp,
  integerpart3,
  currencysymbol3,
  integerpart4,
  currencysymbol4,
  decimalpart3,
  decimalpart4,
  rifd,
  SouthAmerica,
  harmacn,
  cardType,
  homeProducts,
  productDescriptions,
  processedDescriptions,
  x,
  y,

}) {
  const divRef = useRef(null)
  const textRef = useRef(null)
  const [scaleX, setScaleX] = useState(1)
  const department = data.department
  const barcodeRef = useRef(null);
  const [modifiedSvgText, setModifiedSvgText] = useState("");
  const [topValue, settopValue] = useState(16) 
  const [leftValue, setleftValue] = useState(97.9)  
  const [isLeather, setisLeather] = useState(false)  
const [texttt, setTexttt] = useState("")
const [partzero, setPartzero] = useState("")
const [parttwoandthree, setParttwoandthree] = useState("")

const [partzerokids, setPartzerokids] = useState("")
const [parttwoandthreekids, setParttwoandthreekids] = useState("")
const symbol = sizeData?.symbol

console.log("sizeData",data)

  // Bölmek için "/" karakterini kullan
  const selectedFscType = data.company?.fsctype;

  const leatherTypes = [
    "BUFFALO FURSKIN", "BUFFALO LEATHER", "CALF FURSKIN", "COLT LEATHER",
    "COW FURSKIN", "GOAT LEATHER", "HORSE LEATHER", "LAMB FURSKIN",
    "LAMBSKIN", "PIG FURSKIN", "PIG LEATHER", "RABBIT LEATHER",
    "SHEEP FURSKIN", "SHEEP LEATHER"
  ]

  const [brand, category, subCategory] = department ? department.split(' / ') : ['', '', '']
  const filteredIndo = indo.filter((item) => item.amount !== '')
  const indexedIndo = indo.reduce((acc, item, index) => {
    if (item.amount !== '') {
      acc.push(index)
    }
    return acc
  }, [])
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraLogoNewFullfill, width: "7.550mm", height: "auto" },
    fsctm: { component: ZaraLogoNewFullfill, width: "7.550mm", height: "auto" },
    fsctmpaper: { component: ZaraLogoNewFullfill, width: "7.550mm", height: "auto" },
  };

  const SelectedComponent = FSC_COMPONENTS[selectedFscType];

  useEffect(() => {
    if (category) {
      setCurrentShape(category)
    }
  }, [category])

  // Processed descriptions'ı direkt kullan - useEffect kaldırıldı
  const processedData = processedDescriptions[sizeData?.description] || {
    fullText: "",
    partzero: "",
    parttwoandthree: "",
    partzerokids: "",
    parttwoandthreekids: ""
  };

  const handleSvgGenerated = (svgText) => {
    setModifiedSvgText(svgText);
  };
  // Optimized function using pre-cached descriptions
  function getProductTextById(id) {
    return processedDescriptions[id]?.fullText || "";
  }
  
  useEffect(() => {

    // Belirtilen seçiciyle DOM öğesini yakalama
    const textElement = document.querySelector(
      '#root > div.min-h-screen.font-poppins > div > div:nth-child(3) > div:nth-child(1) > div > div > div > div:nth-child(3) > div:nth-child(3) > div.printable > div > div > div > div.tracking-\\[\\.02rem\\] > svg > g > text'
    );

    if (textElement) {
      // Margin top değerini güncelle
      //textElement.style.marginTop = '-10px ';
    } else {
    }
  }, []); // Sadece bileşen yüklendiğinde bir kez çalışacak




  const renderSVG = (integer3, decimal3, integer4, decimal4) => {
    console.log("Values received:", { integer3, decimal3, integer4, decimal4 });
    console.log("SUBCATEGORYY",subCategory);
    // Değerleri stringe çevirip kontrol ediyoruz
    const isInteger3Valid = String(integer3).trim() !== '';
    const isDecimal3Valid = String(decimal3).trim() !== '';
    const isInteger4Valid = String(integer4).trim() !== '';
    const isDecimal4Valid = String(decimal4).trim() !== '';
  if(SouthAmerica)
  {
    return <MySVG2900 width="23.256mm" height="14.496mm" />;
    

  }
  else{
    switch (true) {
      case isInteger3Valid && isDecimal3Valid && isInteger4Valid && isDecimal4Valid:
        console.log("Case 1: All values are present (integer3, decimal3, integer4, decimal4)");
        return <MySVG20 width="21.256mm" height="14.496mm" />;
      case isInteger3Valid && isDecimal3Valid && !isInteger4Valid :
        console.log("Case 2: Only integer3 and decimal3 are present, integer4 and decimal4 are missing");
        return <MySVG249 width="21.256mm" height="14.496mm" />;
      case isInteger4Valid && isDecimal4Valid && !isInteger3Valid:
        console.log("Case 3: Only integer4 and decimal4 are present, integer3 and decimal3 are missing");
        return <MySVG250 width="21.256mm" height="14.496mm" />;
      default:
        console.log("Default Case: None of the conditions are met", { integer3, decimal3, integer4, decimal4 });
        return null; // Hiçbir koşul sağlanmazsa hiçbir şey döndürme
    }
  }
  

  };
 /* 
  <div style={{position:"absolute",left:12,top:-2}}>
  <MySVGTry style={{width:"55.2mm",height:"110.2mm"}}/>

  </div>
  */


  useEffect(() => {
    const adjustScale = () => {
      if (divRef.current && textRef.current) {
        const containerWidth = divRef.current.offsetWidth
        const textWidth = textRef.current.offsetWidth

        if (textWidth > containerWidth) {
          setScaleX(containerWidth / textWidth)
        } else {
          setScaleX(1)
        }
      }
    }

    adjustScale()
    window.addEventListener('resize', adjustScale) // Dinamik ekran boyutu için
    return () => window.removeEventListener('resize', adjustScale)
  }, [filteredIndo, inx])

  

  const valueBasedOnInx = indexedIndo[inx]

  const [currentShape, setCurrentShape] = useState(null)

  const { referance } = useOrderStore()

  const isBlackLabel = referance?.backgroundColor === 'B'

  const isBlack = referance?.backgroundColor === 'B'
  let shape
  const renderCardTypeContent = () => {
    console.log("codeeeee",referance?.code)
    switch (referance?.code) {
      case "LABEL 10 280X70":
        return (

          <div>
          <div>
            <div>
            <Label1011 width="280mm" height="70mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>

              <div
  className="
    absolute text-[6.3pt] leading-[6.8pt] text-justify arialnarrow
   
  "
  style={{
    top: 34,
    left: 687.5,
    width: '335px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    wordSpacing: '-0.8px',

    unicodeBidi: 'plaintext',
    display:"none",

  }}
>{getProductTextById(sizeData.description)}
</div>
{sizeData.pack==="" && (
        <></>
        )}
{sizeData.pack=="Pack 2" && (
        <Pack2 width="10mm" height="3.865mm" style={{position:"absolute",top:115,left:345}}/>
        )}
{sizeData.pack=="Pack 3" && (
  <Pack3 width="10mm" height="3.865mm" style={{position:"absolute",top:115,left:345}}/>

        )}
              <div></div>
           <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:196.6,width:"336px",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",display:"none"}}>
<p className="zara-regular"
                    style={{
                      fontSize: "10pt",

                      color: "black",
                    }}
                  >{processedData.partzero}</p>
                  <p className="zara-regular"
                    style={{
                      fontSize: "10pt",

                      color: "black",
                    }}
                  >{processedData.parttwoandthree}</p>
           </div>
    

                    <div style={{position:"absolute",top:119.5,left:803.5,width:"200px"}}>
                    <span className="pdf-force" style={{fontSize:"5pt",color:"black",letterSpacing:"-0.32px"}}>CONT. {sizeData.pack === "Pack 2" 
          ? "2" 
          : sizeData.pack === "Pack 3" 
          ? "3" 
          : "1"} PIEZAS | PIECES | PIÈCES </span>
                    </div>
         
    
              <div style={{position:"absolute",top:95.4,height:29,left:686.6,width:"336px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="arial-bold"
                    style={{
                      fontSize: "14.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, ' x ')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "14.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                     marginLeft:28,
                     marginRight:-19
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, ' x ')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 97, left: 1033  }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    

    <TempBack width="12.4mm" style={{position:"absolute",    top: 149,
    left: 1021.2}}></TempBack>

     
              <div
  style={{
    position: 'absolute',
    top: 159,
    left: 1007.8,


  }}
>
  <QRCodeComponentLabel10
    barcodeValue={qrcodeValue}
    onSvgGenerated={handleSvgGenerated}
  />
  {modifiedSvgText && (
    <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
  )}
</div>

      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 172.4, left: 695,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 147.8, left: 715.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
          
                  <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
        );
      
      case "LABEL 10 388X70":
        return (
          <div>
             
       
      <div>
        <div>
  
        <Label38870 width="391.141mm" height="72.372mm" style={{position:"absolute",top:1,left:14,opacity:1}}/>

          <div
className="
absolute text-[6.3pt] leading-[6.8pt] text-justify arialnarrow

"
style={{
top: 56,
left: 907.5,
width: '471px',              // kutu 167 kalıyor
fontWeight: 400,
whiteSpace: 'normal',
wordBreak: 'normal',
overflowWrap: 'normal',
wordSpacing: '-0.8px',

unicodeBidi: 'plaintext',
}}
>CONT. {sizeData.pack === "Pack 2" 
          ? "2" 
          : sizeData.pack === "Pack 3" 
          ? "3" 
          : "1"}   PAÑO DE COCINA / PANO DE COZINHA / KITCHEN TOWEL / TORCHON DE CUISINE / THEEDOEK / PANNO DI CUCINA / KÜCHENTUCH / ΚΟΥΖΙΝΟΠΑΝΟ / VISKESTYKKE / ディッシュクロス / 행주 / KÖKSHANDDUK / خرقة المطبخ / PANO DE COCIÑA / DRAP DE CUINA / SUKALDEKO ZAPIA
</div>
{sizeData.pack==="" && (
    <></>
    )}
{sizeData.pack=="Pack 2" && (
    <Pack2 width="10mm" height="3.865mm" style={{position:"absolute",top:109,left:428}}/>
    )}
{sizeData.pack=="Pack 3" && (
  <Pack3 width="10mm" height="3.865mm" style={{position:"absolute",top:109,left:428}}/>

    )}
          <div></div>
       <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:278.6,width:"336px",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",display:"none"}}>
<p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
                    >{processedData.partzero}</p>
              <p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
                    >{processedData.parttwoandthree}</p>
       </div>


       
     

          <div style={{position:"absolute",top:109.5,height:29,left:975.6,width:"337px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="arial-bold"
                style={{
                  fontSize: "14.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                }}
              >{sizeData.cm?.replace(/\s*x\s*/g, ' x ')}</p>
                 <p className="arial-bold"
                style={{
                  fontSize: "14.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                 marginLeft:29,
                 marginRight:-1
                }}
              >{sizeData.inches?.replace(/\s*x\s*/g, ' x ')}</p>
              </div>
  
         
          <div style={{ position: 'absolute', top: 63.5, left: 1427  }}>
          {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>


<TempBack width="12.4mm" style={{position:"absolute",    top: 186,
    left: 1416.6}}></TempBack>
 
          <div
style={{
position: 'absolute',
top: 196,
left: 1403.2,

}}
>
<QRCodeComponentLabel10
barcodeValue={qrcodeValue}
onSvgGenerated={handleSvgGenerated}
/>
{modifiedSvgText && (
<div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
)}
</div>

  
       
   
          <div ref={barcodeRef} style={{ position: 'absolute', top: 171.4, left: 984,width:"35mm",height:"10.310mm"}}>
            <Barcode
              value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
              format="ITF14"
              width={0.921}
              height={25.9}
              marginLeft={1}
              marginRight={1}
              marginTop={1}
              marginBottom={1}  
              background="transparent"
              lineColor={isBlack ? '#ffffff' : '#000000'}
              textMargin={0}
              fontSize={8} // 7pt yaklaşık olarak 9px
              font="Arial"
            />
          </div>

 
          <div style={{ position: 'absolute', top: 147.4, left: 1000.5}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
      
              <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
              {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
              </p>
            </div>{' '}
          </div>
        </div>
      </div>
    </div>
        );
      
        case "LABEL 10 280X70 V2":
          return (
  
            <div>
               

            <div>
              <div>
              <Label28070V2 width="280.071mm" height="70.070mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>

                <div
    className="
      absolute text-[6.3pt] leading-[6.8pt] text-justify arialnarrow
     
    "
    style={{
      top: 34,
      left: 687.5,
      width: '335px',              // kutu 167 kalıyor
      fontWeight: 400,
      whiteSpace: 'normal',
      wordBreak: 'normal',
      overflowWrap: 'normal',
      wordSpacing: '-0.8px',
  
      unicodeBidi: 'plaintext',
      display:"none",
  
    }}
  >{getProductTextById(sizeData.description)}
  </div>
  {sizeData.pack==="" && (
          <></>
          )}
  {sizeData.pack=="Pack 2" && (
          <Pack2 width="10mm" height="3.865mm" style={{position:"absolute",top:132,left:344}}/>
          )}
  {sizeData.pack=="Pack 3" && (
          <Pack3 width="10mm" height="3.865mm" style={{position:"absolute",top:132,left:344}}/>

          )}
                <div></div>
             <div style={{position:"absolute",top:60.4,height:32,letterSpacing:"-0.13px",left:193.9,width:"336px",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",display:"none"}}>
  <p className="zara-regular"
                      style={{
                        fontSize: "10pt",
  
                        color: "black",
                      }}
                    >{processedData.partzero}</p>
                    <p className="zara-regular"
                      style={{
                        fontSize: "10pt",
  
                        color: "black",
                      }}
                    >{processedData.parttwoandthree}</p>
             </div>
      
  
                      <div style={{position:"absolute",top:237.2,left:655.8,width:"200px"}}>
                      <span className="pdf-force" style={{fontSize:"5pt",color:"black",letterSpacing:"-0.32px"}}>CONT. {sizeData.pack === "Pack 2" 
          ? "2" 
          : sizeData.pack === "Pack 3" 
          ? "3" 
          : "1"} PIEZAS | PIECES | PIÈCES </span>
                      </div>
           
      
                <div style={{position:"absolute",top:113.4,height:29,left:686.6,width:"336px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="zara-bold"
                      style={{
                        fontSize: "9pt",
                        lineHeight: "19.7px",
                        letterSpacing: "-0.1px",
                        color: "black",
                      }}
                    >{sizeData.cm?.replace(/\s*x\s*/g, ' x ')}</p>
                       <p className="zara-bold"
                      style={{
                        fontSize: "9pt",
                        lineHeight: "19.7px",
                        letterSpacing: "-0.1px",
                        color: "black",
                       marginLeft:42,
                       marginRight:0
                      }}
                    >{sizeData.inches?.replace(/\s*x\s*/g, ' x ')}</p>
                    </div>
        
               
                    <div style={{ position: 'absolute', top: 97, left: 1033  }}>
                {SelectedComponent && (
        <SelectedComponent.component
          width={SelectedComponent.width}
          height={SelectedComponent.height}
        />
      )}
      </div>
      
  
      <TempBack width="12.4mm" style={{position:"absolute",    top: 149,
    left: 1021.2}}></TempBack>

     
              <div
  style={{
    position: 'absolute',
    top: 159,
    left: 1007.8,


  }}
>
  <QRCodeComponentLabel10
    barcodeValue={qrcodeValue}
    onSvgGenerated={handleSvgGenerated}
  />
  {modifiedSvgText && (
    <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
  )}
</div>



        
             
         
                <div ref={barcodeRef} style={{ position: 'absolute', top: 172.4, left: 695,width:"35mm",height:"10.310mm"}}>
                  <Barcode
                    value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                    format="ITF14"
                    width={0.921}
                    height={25.9}
                    marginLeft={1}
                    marginRight={1}
                    marginTop={1}
                    marginBottom={1}  
                    background="transparent"
                    lineColor={isBlack ? '#ffffff' : '#000000'}
                    textMargin={0}
                    fontSize={8} // 7pt yaklaşık olarak 9px
                    font="Arial"
                  />
                </div>
      
       
                <div style={{ position: 'absolute', top: 147.8, left: 715.5}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
            
                    <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                    {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                    </p>
                  </div>{' '}
                </div>
              </div>
            </div>
          </div>
          );
        
        
        
        
          case "LABEL 10 320X70":
            return (
              <div>
                 
  
    
          <div>
            <div>
            <Label32070 width="320.072mm" height="70.069mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>
    
              <div
    className="
    absolute text-[6pt] leading-[6.8pt] text-justify arialnarrow
    
    "
    style={{
    top: 40,
    left: 736.5,
    width: '331px',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    wordSpacing: '-0.8px',
    
    unicodeBidi: 'plaintext',
    
    }}
    >CONT. {sizeData.pack === "Pack 2" 
          ? "2" 
          : sizeData.pack === "Pack 3" 
          ? "3" 
          : "1"}   PAÑO DE COCINA / PANO DE COZINHA / KITCHEN TOWEL / TORCHON DE CUISINE / THEEDOEK / PANNO DI CUCINA / KÜCHENTUCH / ΚΟΥΖΙΝΟΠΑΝΟ / VISKESTYKKE / ディッシュクロス / 행주 / KÖKSHANDDUK / خرقة المطبخ / PANO DE COCIÑA / DRAP DE CUINA / SUKALDEKO ZAPIA
    </div>
    {sizeData.pack==="" && (
        <></>
        )}
    {sizeData.pack=="Pack 2" && (
        <Pack2 width="10mm" height="3.865mm" style={{position:"absolute",top:120,left:298}}/>
        )}
    {sizeData.pack=="Pack 3" && (
      <Pack3 width="10mm" height="3.865mm" style={{position:"absolute",top:120,left:298}}/>
    
        )}
              <div></div>
           <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:147.6,width:"336px",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",display:"none"}}>
    <p className="zara-regular"
                    style={{
                      fontSize: "10pt",
    
                      color: "black",
                    }}
                  >{processedData.partzero}</p>
                  <p className="zara-regular"
                    style={{
                      fontSize: "10pt",
    
                      color: "black",
                    }}
                  >{processedData.parttwoandthree}</p>
           </div>
    
    
           
         
    
              <div style={{position:"absolute",top:109.5,height:29,left:734.6,width:"337px",display:"flex",justifyContent:"center",alignItems:"center"}}>                  <p className="arial-bold"
                    style={{
                      fontSize: "14.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >{sizeData.cm?.replace(/\s*x\s*/g, ' x ')}</p>
                     <p className="arial-bold"
                    style={{
                      fontSize: "14.3px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      color: "black",
                     marginLeft:29,
                     marginRight:-1
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, ' x ')}</p>
                  </div>
      
             
              <div style={{ position: 'absolute', top: 64.1, left: 674.5  }}>
              {SelectedComponent && (
      <SelectedComponent.component
        width={SelectedComponent.width}
        height={SelectedComponent.height}
      />
    )}
    </div>
    
    <TempBack width="12.4mm" style={{position:"absolute",    top: 187,
    left: 1067.6}}></TempBack>
         
     
              <div
    style={{
    position: 'absolute',
    top: 197,
    left: 1054.2,

    }}
    >
    <QRCodeComponentLabel10
    barcodeValue={qrcodeValue}
    onSvgGenerated={handleSvgGenerated}
    />
    {modifiedSvgText && (
    <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
    )}
    </div>
    
      
           
       
              <div ref={barcodeRef} style={{ position: 'absolute', top: 171.4, left: 731,width:"35mm",height:"10.310mm"}}>
                <Barcode
                  value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                  format="ITF14"
                  width={0.921}
                  height={25.9}
                  marginLeft={1}
                  marginRight={1}
                  marginTop={1}
                  marginBottom={1}  
                  background="transparent"
                  lineColor={isBlack ? '#ffffff' : '#000000'}
                  textMargin={0}
                  fontSize={8} // 7pt yaklaşık olarak 9px
                  font="Arial"
                />
              </div>
    
     
              <div style={{ position: 'absolute', top: 147.4, left: 747.5}}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
          
                  <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                  {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                  </p>
                </div>{' '}
              </div>
            </div>
          </div>
        </div>
            );
          
            case "LABEL 10 320X45":
              return (
                <div>
                   
           
      
            <div>
              <div>
              <Label32045 width="322.453mm" height="45.081mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>
      
      <div style={{position:"absolute",top:9,left:905.5, width: "183px",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column"}}>
              <div
  className="
     text-[4pt] leading-[5.2pt] text-justify pdf-force
   
  "
  style={{

    width: '183',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    letterSpacing: '-0.288px',

    unicodeBidi: 'plaintext',

  }}
              
      
      >CONT.{sizeData.pack === "Pack 2" 
            ? "2" 
            : sizeData.pack === "Pack 3" 
            ? "3" 
            : "1"}   PAÑO DE COCINA / PANO DE COZINHA / KITCHEN TOWEL / TORCHON DE CUISINE / THEEDOEK / PANNO DI CUCINA / KÜCHENTUCH / ΚΟΥΖΙΝΟΠΑΝΟ / VISKESTYKKE / ディッシュクロス / 행주 / KÖKSHANDDUK / خرقة المطبخ / PANO DE COCIÑA / DRAP DE CUINA / SUKALDEKO ZAPIA
            </div>
      <div style={{display:"flex",justifyContent:"center",alignItems:"center",width: "183px",marginLeft:"-1px",marginTop:"-3.8px"}}>
          <p className="zara-semibold"
                      style={{
                        fontSize: "6pt",
                        lineHeight: "19.7px",
                        letterSpacing: "-0.4px",
                        color: "black",
                      }}
                    >{sizeData.cm?.replace(/\s*x\s*/g, ' x ')} /</p>
                       <p className="zara-semibold"
                      style={{
                        fontSize: "6pt",
                        lineHeight: "19.7px",
                        letterSpacing: "-0.4px",
                        color: "black",
          
                      }}
                    >{sizeData.inches?.replace(/\s*x\s*/g, ' x ')}</p>
                    </div>


                    <div
  className="
     text-[4pt] leading-[5.2pt] text-justify pdf-force
   
  "
  style={{

    width: '183',              // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    letterSpacing: '-0.288px',
    marginTop: '-5px',
    unicodeBidi: 'plaintext',

  }}
              
      
      > {data?.country?.translate
        .map((item) => item.translation)
        .join(' / ')}
      </div>
      <div
  className="
    text-[4pt] leading-[5.2pt] text-justify pdf-force
  "
  style={{
    width: '183', // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    letterSpacing: '-0.288px',
    marginTop: '1px',
    unicodeBidi: 'plaintext',
    marginBottom: '1px',
  }}
>
  {sizeData?.fabric
    ?.map((item) =>
      item.mix
        .map((mix) =>
          `${mix.percent ?? ""} ${(mix.text ?? "").toUpperCase()}`
        )
        .join(" / ")
    )
    .join(" / ")}
</div>
      <div
  style={{
    width: '183', // kutu 167 kalıyor
    fontWeight: 400,
    whiteSpace: 'normal',
    wordBreak: 'normal',
    overflowWrap: 'normal',
    letterSpacing: '-0.288px',
    unicodeBidi: 'plaintext',
  }}
>
  <G704Zara width="48.281mm" height="15.668mm" />
</div>

      </div>
      {sizeData.pack==="" && (
          <></>
          )}
      {sizeData.pack=="Pack 2" && (
          <Pack2 width="10mm" height="3.865mm" style={{position:"absolute",top:83,left:525}}/>
          )}
      {sizeData.pack=="Pack 3" && (
        <Pack3 width="10mm" height="3.865mm" style={{position:"absolute",top:83,left:525}}/>
      
          )}

        


                <div></div>
             <div style={{position:"absolute",top:32,height:32,letterSpacing:"-0.13px",left:375.6,width:"336px",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
      <p className="zara-regular"
                      style={{
                        fontSize: "10pt",
      
                        color: "black",
                      }}
                    >PAÑO DE COCINA</p>
                    <p className="zara-regular"
                      style={{
                        fontSize: "10pt",
      
                        color: "black",
                      }}
                    >KITCHEN TOWEL / TORCHON DE CUISINE</p>
             </div>
      
      
             
       
        
               
                <div style={{ position: 'absolute', top: 127.57, left: 183.5 }}>
                {SelectedComponent && (
        <SelectedComponent.component
          width={SelectedComponent.width}
          height={SelectedComponent.height}
        />
      )}
      </div>
      
      
     
      
        
             
         
                <div ref={barcodeRef} style={{ position: 'absolute', top: 25.4, left: 53.6,width:"35mm",height:"10.310mm",transform:"scale(0.85)"}}>
                  <Barcode
                    value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                    format="ITF14"
                    width={0.921}
                    height={25.9}
                    marginLeft={1}
                    marginRight={1}
                    marginTop={1}
                    marginBottom={1}  
                    background="transparent"
                    lineColor={isBlack ? '#ffffff' : '#000000'}
                    textMargin={0}
                    fontSize={8} // 7pt yaklaşık olarak 9px
                    font="Arial"
                  />
                </div>
      
       
                <div style={{ position: 'absolute', top: 8.11, left: 79.5}}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
            
                    <p className="helve-roman" style={{ fontSize: '6.1pt', marginLeft: '-2px',letterSpacing:"-0.05px" }}>
                    {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                    </p>
                  </div>{' '}
                </div>
              </div>
            </div>
          </div>
              );
            


      default:
        // Eğer cardType yoksa veya tanınmıyorsa, mevcut renderShape'i kullan
        <></>
    }
  };
  
  const renderCardKidsTypeContent = () => {
    switch (referance?.code) {
      case "LABEL 10 KIDS 115x136":
        return (

          <div>
                 
          <div
            style={{
              position: 'absolute',
              top: 38.5,
              left: 1082,

              justifyContent: 'center',
              display: 'grid',
              alignItems: 'center',
              textAlign: 'center',
              display: 'none',
            }}
          >
            {rifd && (
                <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
            )}
          </div>

      <div>
        <div>
        <LabelKıds115x136 width="237.370mm" height="136.141mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>

          <div
className="
absolute text-[6pt] leading-[6.8pt] text-justify arial-regular

"
style={{
top: 40,
left: 336.5,
width: '331px',              // kutu 167 kalıyor
fontWeight: 400,
whiteSpace: 'normal',
wordBreak: 'normal',
overflowWrap: 'normal',
wordSpacing: '-0.8px',
transform: "scaleX(-1) scaleY(-1)",
unicodeBidi: 'plaintext',

}}
>Cont. {sizeData.pack === "Pack 2" 
      ? "2" 
      : sizeData.pack === "Pack 3" 
      ? "3" 
      : "1"} <div style={{display:"none"}}>{getProductTextById(sizeData.description)}</div>
</div>
{sizeData.pack==="" && (
    <></>
    )}
{sizeData.pack=="Pack 2" && (
    <Pack2 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:11,left:211}}/>
    )}
{sizeData.pack=="Pack 3" && (
  <Pack3 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:11,left:211}}/>

    )}  
          <div></div>
       <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:147.6,width:"336px",display:"none",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
<p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
              >{processedData.partzerokids}</p>
              <p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
              >{processedData.parttwoandthreekids}</p>
       </div>


       
     

          <div style={{position:"absolute",top:144,height:29,left:64,width:"337px",display:"flex",justifyContent:"center",alignItems:"center",transform: "scaleX(-1) scaleY(-1)"}}>                  <p className="arial-bold"
                style={{
                  fontSize: "14.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                }}
              >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                 <p className="arial-bold"
                style={{
                  fontSize: "14.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                 marginLeft:31.7,
                 marginRight:-2.7
                }}
              >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
              </div>
  
         
          <div style={{ position: 'absolute', top: 132.1, left: 22.5  ,transform: "scaleX(-1) scaleY(-1)"}}>
          {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>


     
 
          <div
style={{
position: 'absolute',
top: 163,
left: 1,

}}
>
<QRCodeComponentLabel10
barcodeValue={qrcodeValue}
onSvgGenerated={handleSvgGenerated}
/>
{modifiedSvgText && (
<div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
)}
</div>

  
       
   
          <div ref={barcodeRef} style={{ position: 'absolute', top: 75.4, left: 260,width:"35mm",height:"10.310mm",transform: "scaleX(-1) scaleY(-1)"}}>
            <Barcode
              value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
              format="ITF14"
              width={0.921}
              height={25.9}
              marginLeft={1}
              marginRight={1}
              marginTop={1}
              marginBottom={1}  
              background="transparent"
              lineColor={isBlack ? '#ffffff' : '#000000'}
              textMargin={0}
              fontSize={8} // 7pt yaklaşık olarak 9px
              font="Arial"
            />
          </div>

 
          <div style={{ position: 'absolute', top: 123.4, left: 309.5}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
      
              <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px",transform: "scaleX(-1) scaleY(-1)" }}>
              {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
              </p>
            </div>{' '}
          </div>
        </div>
      </div>
    </div>
        );
      
      case "LABEL 10 KIDS 100x200":
        return (
          <div>
                 
                 <div
  style={{
    position: 'absolute',
    top: 682.5,
    left: 133,
    justifyContent: 'center',
    display: 'grid',
    alignItems: 'center',
    textAlign: 'center',
    transform: 'rotate(90deg) scale(0.8)',
  }}
>
            {rifd && (
                <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
            )}
          </div>

      <div>
        <div>
        <LabelKıds100x200 width="100mm" height="200mm" style={{position:"absolute",top:5,left:14,opacity:1}}/>

          <div
className="
absolute text-[6pt] leading-[6.8pt] text-justify arial-regular

"
style={{
top: 263,
left: -2.3,
width: '331px',              // kutu 167 kalıyor
fontWeight: 400,
whiteSpace: 'normal',
wordBreak: 'normal',
overflowWrap: 'normal',
wordSpacing: '-0.8px',
unicodeBidi: 'plaintext',
transform: 'rotate(90deg)',
}}
>Cont. {sizeData.pack === "Pack 2" 
      ? "2" 
      : sizeData.pack === "Pack 3" 
      ? "3" 
      : "1"} <div style={{display:"none"}}>{getProductTextById(sizeData.description)}</div>
</div>
{sizeData.pack==="" && (
    <></>
    )}
{sizeData.pack=="Pack 2" && (
    <Pack2 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:40,left:266,transform: 'rotate(-90deg)'}}/>
    )}
{sizeData.pack=="Pack 3" && (
  <Pack3 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:40,left:266,transform: 'rotate(-90deg)'}}/>

    )}  
          <div></div>
       <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:147.6,width:"336px",display:"none",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
<p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
              >{processedData.partzerokids}</p>
              <p className="zara-regular"
                style={{
                  fontSize: "10pt",

                  color: "black",
                }}
              >{processedData.parttwoandthreekids}</p>
       </div>


       
     

          <div style={{position:"absolute",top:591,height:29,left:-39,width:"337px",display:"flex",justifyContent:"center",alignItems:"center",transform: "rotate(90deg)"}}>                  <p className="arial-bold"
                style={{
                  fontSize: "12.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                }}
              >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                 <p className="arial-bold"
                style={{
                  fontSize: "12.3px",
                  lineHeight: "19.7px",
                  letterSpacing: "0px",
                  color: "black",
                 marginLeft:18.7,
                 marginRight:-2.7
                }}
              >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
              </div>
  
         
          <div style={{ position: 'absolute', top: 713, left: 62  ,transform: "rotate(90deg)"}}>
          {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>


     
 
          <div
style={{
position: 'absolute',
top: 694,
left: 113,

}}
>
<QRCodeComponentLabel10
barcodeValue={qrcodeValue}
onSvgGenerated={handleSvgGenerated}
/>
{modifiedSvgText && (
<div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
)}
</div>

  
       
   
          <div ref={barcodeRef} style={{ position: 'absolute', top: 272.4, left: -1,width:"35mm",height:"10.310mm",transform: "rotate(90deg)"}}>
            <Barcode
              value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
              format="ITF14"
              width={0.921}
              height={25.9}
              marginLeft={1}
              marginRight={1}
              marginTop={1}
              marginBottom={1}  
              background="transparent"
              lineColor={isBlack ? '#ffffff' : '#000000'}
              textMargin={0}
              fontSize={8} // 7pt yaklaşık olarak 9px
              font="Arial"
            />
          </div>

 
          <div style={{ position: 'absolute', top: 266.4, left: 67}}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
      
              <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px",transform: "rotate(90deg)" }}>
              {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
              </p>
            </div>{' '}
          </div>
        </div>
      </div>
    </div>
        );
        case "LABEL 10 KIDS 100x200WM":
          return (
            <div>
                   
                   <div
    style={{
      position: 'absolute',
      top: 681,
      left: 141,
      justifyContent: 'center',
      display: 'grid',
      alignItems: 'center',
      textAlign: 'center',
      transform: 'rotate(90deg) scale(0.8)',
    }}
  >
              {rifd && (
                  <ALARMHOME className="alarmIcon" width="8mm" height="auto"  />
              )}
            </div>
  
        <div>
          <div>

          <div style={{position:"absolute",top:-1.5,left:332}}>
          <div className="flex items-center h-full" style={{position:"absolute", top:391, right:400,transform: "rotate(90deg) scale(1)",height:60 }}>
              <div className="flex items-center h-full ">
           <div className="flex items-start justify-between px-[6mm] w-full" >
           <div
  className="w-[21.3mm] h-[14mm] grid grid-cols-5 grid-rows-3 place-items-center items-start gap-x-0 gap-y-[-1px]"
 
>
  {/* Üst sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}.svg`}
    alt="sembol icon"
    style={{ width: 13, height: 14, padding: 0.4 ,marginLeft:1.4,marginTop:-0.6}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}.svg`}
    alt="sembol icon"
    style={{ width: 14, height: 15, padding: 0.4,marginTop:-1,marginLeft:-1.2,opacity:1 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 10.5, padding: 0.4,marginLeft:-1,marginTop:1.8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}.svg`}
    alt="sembol icon"
    style={{ width: 13.5, height: 12, padding: 0.4,marginTop:1.1,marginLeft:-2 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}.svg`}
    alt="sembol icon"
    style={{ width: 11.5, height: 11.5, padding: 0.4 ,marginLeft:-1.6,marginTop:1.3}}
  />

  {/* Orta sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_1.svg`}
    alt="sembol icon"
    style={{  width: 13, height: 12.6, padding: 0.4 ,marginLeft:-1.6,marginTop:4.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_1.svg`}
    alt="sembol icon"
    style={{ width: 14.7, height: 14.7, padding: 0.4 ,marginLeft:-2,marginTop:3.5 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_1.svg`}
    alt="sembol icon"
    style={{  width: 12.8, height: 14.4, padding: 0.4 ,marginLeft:-2.2,marginTop:3}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_1.svg`}
    alt="sembol icon"
    style={{  width: 12.9, height: 12.9, padding: 0.4 ,marginLeft:-2.6,marginTop:3.9}}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_1.svg`}
    alt="sembol icon"
    style={{ width: 10.5, height: 11.5, padding: 0.4 ,marginLeft:-2,marginTop:4.7 }}
  />

  {/* Alt sıra */}
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/wash/${symbol['wash']}_2.svg`}
    alt="sembol icon"
    style={{ width: 17.5, height: 17.2, padding: 0.4 ,marginLeft:1,marginTop:6.4 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/bleach/${symbol['bleach']}_2.svg`}
    alt="sembol icon"
    style={{ width: 13, height: 13, padding: 0.4 ,marginLeft:-0.2,marginTop:8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/tumble/${symbol['tumble']}_2.svg`}
    alt="sembol icon"
    style={{ width: 10.8, height: 10.8, padding: 0.4 ,marginLeft:-0.9,marginTop:8.8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/iron/${symbol['iron']}_2.svg`}
    alt="sembol icon"
    style={{ width: 15, height: 11.6, padding: 0.4 ,marginLeft:-1.7,marginTop:8 }}
  />
  <img
    src={`${BASE_URL2}/imageshome/${isBlackLabel ? 'symbolsWhite' : 'symbols'}/dry/${symbol['dry']}_2.svg`}
    alt="sembol icon"
    style={{ width: 12, height: 12, padding: 0.4 ,marginLeft:-1.4,marginTop:8 }}
  />
</div>

        
          </div>
        </div>
        <div
  className="
  absolute text-[6pt] leading-[6pt] arial-regular
  
  "
  style={{
  top: -56,
  left: -280.3,
  width: '605px',              // kutu 167 kalıyor
  fontWeight: 400,
  whiteSpace: 'normal',
  wordBreak: 'normal',
  overflowWrap: 'normal',
  letterSpacing: '-0.2px',
  wordSpacing: '-0.8px',
  unicodeBidi: 'plaintext',
  textAlign: 'center',

  }}
  >
   {data.country.translate.map((item) => item.translation).join(" / ")}
  </div>
          </div>
          <div style={{position:"relative",width:"52mm",height:"90mm",marginTop:-1}}>
          <div
                style={{
                  position: 'absolute',
                  bottom: 39.3,
                  left: 10.3,
    
                  justifyContent: 'center',
                  display: 'grid',
                  alignItems: 'center',
                  textAlign: 'center',
                  transform:"scaleY(-1) scaleX(-1)"
                }}
              >


<div className="text-[4.6pt] leading-[5.4pt] text-justify pdf-force"  style={{transform:"scaleY(-1) scaleX(-1)"}}>
<div style={{ marginBottom: 5,marginLeft:2 }}>

</div>




</div>



              
              </div>

            
             
          </div>
          </div>

          <LabelKıds100x200WM width="100.106mm" height="200.105mm " style={{position:"absolute",top:5,left:14,opacity:1}}/>
 
            <div
  className="
  absolute text-[6pt] leading-[6.8pt] text-justify arial-regular
  
  "
  style={{
  top: 241,
  left: 1.7,
  width: '331px',              // kutu 167 kalıyor
  fontWeight: 400,
  whiteSpace: 'normal',
  wordBreak: 'normal',
  overflowWrap: 'normal',
  letterSpacing: '-0.2px',
  wordSpacing: '-0.8px',
  unicodeBidi: 'plaintext',
  transform: 'rotate(90deg)',
  }}
  >Cont. {sizeData.pack === "Pack 2" 
        ? "2" 
        : sizeData.pack === "Pack 3" 
        ? "3" 
        : "1"} <div style={{display:"none"}}>{getProductTextById(sizeData.description)}</div>
  </div>
  {sizeData.pack==="" && (
      <></>
      )}
  {sizeData.pack=="Pack 2" && (
      <Pack2 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:40,left:266,transform: 'rotate(-90deg)'}}/>
      )}
  {sizeData.pack=="Pack 3" && (
    <Pack3 width="10.7396mm" height="4.1522mm" style={{position:"absolute",bottom:40,left:266,transform: 'rotate(-90deg)'}}/>
  
      )}  
            <div></div>
         <div style={{position:"absolute",top:50.4,height:32,letterSpacing:"-0.13px",left:147.6,width:"336px",display:"none",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
  <p className="zara-regular"
                  style={{
                    fontSize: "10pt",
  
                    color: "black",
                  }}
                >{processedData.partzerokids}</p>
                <p className="zara-regular"
                  style={{
                    fontSize: "10pt",
  
                    color: "black",
                  }}
                >{processedData.parttwoandthreekids}</p>
         </div>
  
  
         
       
  
            <div style={{position:"absolute",top:615,height:29,left:-45,width:"337px",display:"flex",justifyContent:"center",alignItems:"center",transform: "rotate(90deg)"}}>                  <p className="arial-bold"
                  style={{
                    fontSize: "12.3px",
                    lineHeight: "19.7px",
                    letterSpacing: "0.7px",
                    color: "black",
                  }}
                >{sizeData.cm?.replace(/\s*x\s*/g, 'x')}</p>
                   <p className="arial-bold"
                  style={{
                    fontSize: "12.3px",
                    lineHeight: "19.7px",
                    letterSpacing: "0.7px",
                    color: "black",
                   marginLeft:18.7,
                   marginRight:-2.7
                  }}
                >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                </div>
    
           
            <div style={{ position: 'absolute', top: 713, left: 113  ,transform: "rotate(90deg)"}}>
            {SelectedComponent && (
    <SelectedComponent.component
      width={SelectedComponent.width}
      height={SelectedComponent.height}
    />
  )}
  </div>
  
  
       
   
            <div
  style={{
  position: 'absolute',
  top: 651,
  left: 51,
  transform: 'rotate(90deg)',
  
  }}
  >
  <QRCodeComponentLabel10
  barcodeValue={qrcodeValue}
  onSvgGenerated={handleSvgGenerated}
  />
  {modifiedSvgText && (
  <div dangerouslySetInnerHTML={{ __html: modifiedSvgText }}></div>
  )}
  </div>
  
    
         
     
            <div ref={barcodeRef} style={{ position: 'absolute', top: 115.4, left: -1,width:"35mm",height:"10.310mm",transform: "rotate(90deg)"}}>
              <Barcode
                value={barcodeValue.length === 13 ? barcodeValue : '0390547180002'}
                format="ITF14"
                width={0.921}
                height={25.9}
                marginLeft={1}
                marginRight={1}
                marginTop={1}
                marginBottom={1}  
                background="transparent"
                lineColor={isBlack ? '#ffffff' : '#000000'}
                textMargin={0}
                fontSize={8} // 7pt yaklaşık olarak 9px
                font="Arial"
              />
            </div>
  
   
            <div style={{ position: 'absolute', top: 114.4, left: 75.5}}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
        
                <p className="helve-roman" style={{ fontSize: '7.1pt', marginLeft: '-2px',letterSpacing:"-0.05px",transform: "rotate(90deg)" }}>
                {`${data.articleNo}/${data.priceLabel[selectColor].colorCode}/${sizeData.name}`}
                </p>
              </div>{' '}
            </div>
          </div>
        </div>
      </div>
          );
        


      default:
        // Eğer cardType yoksa veya tanınmıyorsa, mevcut renderShape'i kullan
        <></>
    }
  };

  return (
    <div>
    {category==="Kids" && (
      renderCardKidsTypeContent()
    )}
    {category!=="Kids" && (
      renderCardTypeContent()
    )}

    </div>
  )
}
